import { postGuestWebSignupV2, postWebSignupV2 } from "@/api/Api";
import { tokenStorage } from "@/api/tokenStorage";
import { getStoredOnboardingForSubmission } from "@/hooks/useOnboarding";
import {
  clearStoredOnboardingWords,
  getStoredOnboardingWords,
} from "@/lib/onboardingWords";
import { WebSignupV2Request } from "@shared_types";

const CHECKOUT_SESSION_ID_KEY = "webSignupCheckoutSessionId";
const CHECKOUT_SKU_KEY = "webSignupSku";

export type WebSignupCheckoutSession = {
  checkoutSessionId: string;
  sku: string;
};

export type WebSignupCredentials = {
  email: string;
  password: string;
  displayName: string;
};

export function saveWebSignupCheckoutSession(
  session: WebSignupCheckoutSession,
): void {
  localStorage.setItem(CHECKOUT_SESSION_ID_KEY, session.checkoutSessionId);
  localStorage.setItem(CHECKOUT_SKU_KEY, session.sku);
}

export function getWebSignupCheckoutSession(): WebSignupCheckoutSession | null {
  const checkoutSessionId = localStorage.getItem(CHECKOUT_SESSION_ID_KEY) || "";
  const sku = localStorage.getItem(CHECKOUT_SKU_KEY) || "";
  if (!checkoutSessionId || !sku) {
    return null;
  }
  return { checkoutSessionId, sku };
}

export function clearWebSignupCheckoutSession(): void {
  localStorage.removeItem(CHECKOUT_SESSION_ID_KEY);
  localStorage.removeItem(CHECKOUT_SKU_KEY);
}

export function assertStoredWebSignupReady(): void {
  if (!getWebSignupCheckoutSession()) {
    throw new Error("Missing checkout session");
  }
  getStoredOnboardingForSubmission();
}

export async function submitStoredWebSignup(
  credentials?: WebSignupCredentials
): Promise<void> {
  const checkoutSession = getWebSignupCheckoutSession();
  if (!checkoutSession) {
    throw new Error("Missing checkout session");
  }
  const data: WebSignupV2Request = {
    checkoutSessionId: checkoutSession.checkoutSessionId,
    sku: checkoutSession.sku,
    email: credentials?.email,
    password: credentials?.password,
    displayName: credentials?.displayName,
    onboarding: getStoredOnboardingForSubmission(),
    onboardingWords: getStoredOnboardingWords(),
  };
  const response = credentials
    ? await postGuestWebSignupV2(data)
    : await postWebSignupV2(data);
  if (response.authToken) {
    tokenStorage.setToken(response.authToken);
  }
  clearWebSignupCheckoutSession();
  clearStoredOnboardingWords();
}
